import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import module from "./MypageLayout.module.css";
import Footer from "../atomic/organisms/Footer";

export default function MypageLayout() {
  return (
    <>
      <Header />
      <div className={module.container}>
        <Outlet />
      </div>
      <Footer />
    </>
  );
}
